// Copyright (c) Docugami, Inc. All rights reserved.

import { Config } from "config";
import { useDgAuth } from "hooks/DgAuthentication"

const TEMPLATE_IDS = ["255608395", "255610467", "255610471", "255611067"]
export const ZapierWorkflow = (): JSX.Element => {
    const { user } = useDgAuth();

    return (
        <zapier-workflow
            sign-up-email={user?.email}
            sign-up-first-name={user?.given_name}
            sign-up-last-name={user?.family_name}
            client-id={Config.zapierClientId}
            theme="light"
            intro-copy-display="hide"
            manage-zaps-display="show"
            guess-zap-display="hide"
            app-search-bar-display="show"
            template-ids={TEMPLATE_IDS}
            template-cta-display="show"
            zap-create-from-scratch-display="hide"
        />
    )
}
